import { createContext } from 'react';
import type { BookingStore } from './bookingStoreType';

export const BookingStoreContext = createContext<BookingStore | null>(null);
